/// <reference path="../../Common/Helpers/GridEditorBase.ts" />
/// <reference path="../../_ext/editors/grideditorbase.ts" />
namespace TabAurous.OMS {
    import fld = TargetMasterRow.Fields;

    @Serenity.Decorators.registerClass()
    export class TargetMasterEditor extends Common.GridEditorBase<TargetMasterRow> {
        protected getColumnsKey() { return "OMS.TargetMaster"; }
        protected getDialogType() { return TargetMasterDialog; }
        protected getLocalTextPrefix() { return TargetMasterRow.localTextPrefix; }
        exchangerate: number;
        private pendingChanges: Q.Dictionary<any> = {};

        rateid: string;
        public companyid: number;
        constructor(container: JQuery) {
            super(container);
            this.slickContainer.on('change', '.edit:input', (e) => this.inputsChange(e));
        }
        public getColumns() {

            var columns = super.getColumns();

            var num = ctx => ColumnFormatter.numericInputFormatter(ctx, this);
            var int = ctx => ColumnFormatter.integerInputFormatter(ctx, this);
            var wt = ctx => ColumnFormatter.WeightFormatter(ctx, this);
            var amt = ctx => ColumnFormatter.AmountFormatter(ctx, this);
            var str = ctx => ColumnFormatter.stringInputFormatter(ctx, this);

            var FinancialYear = Q.first(columns, x => x.field === fld.FinancialYearId);
            FinancialYear.referencedFields = [fld.FinancialYearId];
            FinancialYear.format = ctx => ColumnFormatter.selectFormatter(ctx, fld.FinancialYearId, OMS.FinancialYearRow.getLookup(),this);

            var Target = Q.first(columns, x => x.field === fld.TargetDistributionId);
            Target.referencedFields = [fld.TargetDistributionId];
            Target.format = ctx => ColumnFormatter.selectFormatter(ctx, fld.TargetDistributionId, Master.TargetDistributionRow.getLookup(),this);

            var BaseItem = Q.first(columns, x => x.field === fld.BaseItemTypeId);
            BaseItem.referencedFields = [fld.BaseItemTypeId];
            BaseItem.format = ctx => ColumnFormatter.selectFormatter(ctx, fld.BaseItemTypeId, Q.getLookup<ProductTypeRow>('Jewellery'),this);

            Q.first(columns, x => x.field === fld.Quantity).format = int;
            Q.first(columns, x => x.field === fld.Amount).format = amt;


            columns.unshift({
                field: 'Delete Row',
                name: '',
                format: ctx => '<a class="inline-action delete-row" title="delete">' +
                    '<i class="fa fa-trash-o text-red"></i></a>',
                width: 24,
                minWidth: 24,
                maxWidth: 24
            });



            return columns;
        }

        //#region  ItemGrid Inline Editor

        // **** Onclick Event ****
        protected onClick(e: JQueryEventObject, row: number, cell: number) {
            super.onClick(e, row, cell);


            if (e.isDefaultPrevented())
                return;

            var item = this.itemAt(row);
            var target = $(e.target);

            // if user clicks "i" element, e.g. icon
            if (target.parent().hasClass('inline-action'))
                target = target.parent();

            if (target.hasClass('inline-action')) {
                e.preventDefault();

                if (target.hasClass('delete-row')) {

                    //TODO: Validate for TransItemID in RefTransItemID in Stock
                    Q.confirm('Are you sure want to Delete? ', () => {

                        var id = this.id(item);


                        this.view.deleteItem(id);

                    });

                    this.view.refresh();
                }

                if (target.hasClass('edit numeric')) {
                    super.onClick(e, row, cell);
                }
            }

            

        }

        //Row Edit Event handler
        private inputsChange(e: JQueryEventObject) {
            var cell = this.slickGrid.getCellFromEvent(e);
            var item = this.itemAt(cell.row);
            var input = $(e.target);
            var field = input.data('field');
            var text = Q.coalesce(Q.trimToNull(input.val()), '0');
            var id = this.id(item);
            var pending = this.pendingChanges[id];

            // *** Format Number ***
            var effective = this.getEffectiveValue(item, field);
            var oldText: string = input.hasClass('numeric')
                ? Q.formatNumber(effective, '0.00')
                : effective as string;

            var value;

            // *** Validate Decimal & Integer***
            if (field === fld.Quantity || field === fld.Amount) {
                value = Q.parseDecimal(text);
                if (value == null || isNaN(value)) {
                    Q.notifyError(Q.text('Validation.Decimal'), '', null);
                    input.val(oldText);
                    input.focus();
                    return;
                }
            }
            else {
                value = text;
            }

            if (field === fld.Quantity && value >= 0) {
                item[field] = value;
            }

            if (field === fld.Amount && value >= 0) {
                item[field] = value;

            }
            if (field === fld.FinancialYearId && value > 0) {
                item[field] = value;

            }
            if (field === fld.TargetDistributionId && value > 0) {
                item[field] = value;

            }
            if (field === fld.BaseItemTypeId && value > 0) {
                item[field] = value;

            }
            this.view.updateItem(id, item);
            this.view.refresh();

            if (input.hasClass('numeric'))
                value = Q.formatNumber(value, '0.00');

            if (input.hasClass('integer'))
                value = Q.formatNumber(value, '0');

            input.val(value).addClass('dirty');
        }


        private getEffectiveValue(item, field: any): any {
            var id = this.id(item);
            var pending = this.pendingChanges[id];
            if (pending && pending[field] !== undefined) {
                return pending[field];
            }
            return item[field];
        }

        protected onViewProcessData(response) {
            this.pendingChanges = {};
            return super.onViewProcessData(response);
        }

        // #endregion


        protected getButtons() {
            let buttons = super.getButtons();
            var grid = Common.ProductSelectGrid;
            buttons.pop();
            // *** Add Select Button to Grid Editor ***
            buttons.push({
                title: "Add Target",
                cssClass: "stock-button",
                hotkey: "alt+k",
                hint: 'alt+k',
                onClick: () => {
                    var items = this.view.getItems();
                    var baseitems = ProductTypeRow.getLookup().items[0].ProductTypeId;

                    var item: TargetMasterRow = {
                        Amount: 0,
                        BaseItemTypeId: baseitems,
                        FinancialYearId: Q.Authorization.userDefinition.FinancialYearId,
                        Quantity: 0,
                        TargetDistributionId: Master.TargetDistributionRow.getLookup().items[0].TargetDistributionId
                    };
                    item[this.getIdProperty()] = "`" + this.nextId++;

                    this.view.addItem(item);


                }
            });

            return buttons;
        }
        validateEntity(row, id) {
            var sameProduct = Q.tryFirst(this.view.getItems(), x => x.BaseItemTypeId === row.BaseItemTypeId);
            if (sameProduct && this.id(sameProduct) !== id) {
                Q.alert('This Product Type already exists!');
                return false;
            }
            //row.LineTotal = (row.Quantity || 0) * (row.UnitPrice || 0) - (row.Discount || 0);
            return true;
        }



    }
}